import { render, staticRenderFns } from "./product.vue?vue&type=template&id=426ee912&scoped=true&"
import script from "./product.vue?vue&type=script&lang=babel&"
export * from "./product.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ee912",
  null
  
)

export default component.exports